import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { MMXIconComponent } from './mmx-icon.component'

@NgModule({
  imports: [CommonModule],
  exports: [MMXIconComponent],
  declarations: [MMXIconComponent],
})
export class MMXIconModule {}
